import axios, { AxiosError } from "axios";
import type { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { clearOnLogout, env, getToken } from "@/lib/utils";
import toast from "@/lib/toast";
import { getDeviceName } from "@/lib/device.util";
const deviceName = getDeviceName()

const config = {
  baseURL: env("VITE_API_BASE_URL"),
  timeout: 30000,
  headers: {
    "ngrok-skip-browser-warning": "69420",
    "x-device-name": deviceName,
    "x-platform": "web",
  },
};

const publicRequest = axios.create(config);
const privateRequest = axios.create(config);

const requestHandler = (
  request: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const token = getToken() || "";
  request.headers = request.headers ?? {};

  request.params = {
    ...request.params,
  };

  if ("Authorization" in request.headers) {
    (request.headers as any).Authorization = `Bearer ${token}`;
  } else {
    Object.assign(request.headers, { Authorization: `Bearer ${token}` });
  }

  return request;
};

const responseErrorHandler = (error: AxiosError) => {
  if (error.response) {
    const { status, data } = error.response;
    const message = (data as any)?.message || error.message;

    if (status === 401) {
      clearOnLogout();
      window.location.href = "/";
      toast.warning("Session expired, please login");
    } else {
      toast.error(message || "Some Error Occurred");
    }
  } else {
    toast.error(error?.message || "Some Error Occurred");
  }

  return Promise.reject(error);
};

const errorHandler = (error: AxiosError) => {
  return Promise.reject(error);
};

privateRequest.interceptors.request.use(requestHandler, errorHandler);

privateRequest.interceptors.response.use(
  (response: AxiosResponse) => response,
  responseErrorHandler,
);

export { privateRequest, publicRequest };
